import { defineMessages } from 'react-intl';

import generalMessages from 'src/messages';

const messages = defineMessages({
  // VOLUME
  emptyNormalizationVolumeInputError: {
    id: 'emptyNormalizationVolumeInputError',
    defaultMessage: 'Volume field is required!',
  },
  noNrNormalizationVolumeError: {
    id: 'noNrNormalizationVolumeError',
    defaultMessage: 'Volume field should contain only numbers!',
  },
  minNrNormalizationVolumeError: {
    id: 'minNrNormalizationVolumeError',
    defaultMessage: 'Minimum quantity for Volume normalization is 10.',
  },
  maxNrNormalizationVolumeError: {
    id: 'maxNrNormalizationVolumeError',
    defaultMessage: 'Maximum quantity for Volume normalization is {value}.',
  },
  // CONCENTRATION
  emptyNormalizationConcentrationInputError: {
    id: 'emptyNormalizationConcentrationInputError',
    defaultMessage: 'Concentration field is required!',
  },
  noNrNormalizationConcentrationError: {
    id: 'noNrNormalizationConcentrationError',
    defaultMessage: 'Concentration field should contain only numbers!',
  },
  minNrNormalizationConcentrationUmError: {
    id: 'minNrNormalizationConcentrationUmError',
    defaultMessage: 'Minimum quantity for concentration normalization is 1 uM.',
  },
  maxNrNormalizationConcentrationUmError: {
    id: 'maxNrNormalizationConcentrationUmError',
    defaultMessage: 'Maximum quantity for concentration normalization is 250 uM.',
  },
  minNrNormalizationConcentrationUgUlError: {
    id: 'minNrNormalizationConcentrationUgUlError',
    defaultMessage: 'Minimum quantity for concentration normalization is 0.5 ug/ul.',
  },
  maxNrNormalizationConcentrationUgUlError: {
    id: 'maxNrNormalizationConcentrationUgUlError',
    defaultMessage: 'Maximum quantity for concentration normalization is 10 ug/ul.',
  },
});

export default { ...generalMessages, ...messages };
